import styled from 'styled-components';

import { BREAKPOINTS } from 'constants/breakpoints';
import { Table, TableHeader, TableRow } from 'components/ui/StyledTable';

import { colours } from 'themes/default';

const MOBILE_BREAKPOINT = `${BREAKPOINTS.lg.max}px`;

export const CasesTable = styled(Table)`
  grid-template-columns: auto auto auto auto 1fr;
  column-gap: 24px;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    grid-template-columns: 1fr;
  }
`;

export const CasesTableHeader = styled(TableHeader)`
  grid-template-columns: subgrid;
  column-gap: 24px;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    display: none;
  }
`;

export const CaseRow = styled(TableRow)`
  grid-template-columns: subgrid;
  column-gap: 24px;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    row-gap: 4px;
  }
`;

export const MobileLabel = styled.span`
  display: none;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    display: inline;
    margin-right: 8px;
    font-weight: bold;
  }
`;

export const Status = styled.span`
  color: ${(props) => (props.$active ? colours.Messaging.ErrorRed : colours.Greyscale.Black)};
`;
